/**
 * <appointment-opener>
 *
 * Wraps the "Book An Appointment" button on each flagship store card.
 * When clicked, it tells the shared <appointment-form> controller which
 * city + Klaviyo list this appointment is for, then defers to Prestige's
 * native aria-controls plumbing to actually open the modal.
 *
 * Required data attributes (set in flagship-store-card.liquid):
 *   data-list-id   — the Klaviyo list ID for this store
 *   data-location  — the store display name (e.g. "Los Angeles")
 *
 * Required inner markup:
 *   <button aria-controls="ModalDrawer-AppointmentForm">…</button>
 */
if (!customElements.get('appointment-opener')) {
  class AppointmentOpener extends HTMLElement {
    constructor() {
      super();
      this.list = this.dataset.listId;
      this.location = this.dataset.location;
      this.handleClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    onClick(event) {
      const trigger = event.target.closest('button, a');
      if (!trigger || !this.contains(trigger)) return;

      const form = document.querySelector('#AppointmentForm');
      if (!form) return;

      const controller = form.closest('appointment-form');
      if (controller && typeof controller.setLocation === 'function') {
        controller.setLocation(this.location, this.list);
      }
    }
  }

  customElements.define('appointment-opener', AppointmentOpener);
}
